import React, { useEffect, useMemo, useState } from "react";
import { apiFetch } from "../../commons/axiosReq";
import "./UniversityAcademicStructureManager.css";

export default function UniversityAcademicStructureManager({ universities = [] }) {
  const [allUniversities, setAllUniversities] = useState(universities);
  const [universityId, setUniversityId] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [relations, setRelations] = useState([]);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const selectedUniversity = useMemo(
    () => allUniversities.find((item) => String(item.universityId) === String(universityId)),
    [allUniversities, universityId]
  );

  useEffect(() => {
    apiFetch("University/GetUniversitiesForAdmin", "get").then((result) => {
      if (result.ok) setAllUniversities(Array.isArray(result.data) ? result.data : result.data?.data || universities);
    });
  }, [universities]);

  const loadRelations = async (selectedId = universityId) => {
    if (!selectedId) { setRelations([]); return; }
    const result = await apiFetch(`CollegeField/GetCollegeFieldsByUniversity/${selectedId}`, "get");
    if (!result.ok) { setRelations([]); setMessage(result.error || "دریافت ساختار دانشگاه انجام نشد."); return; }
    setRelations(Array.isArray(result.data) ? result.data : result.data?.data || []);
  };

  useEffect(() => { loadRelations(); }, [universityId]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async () => {
    if (!universityId) return setMessage("ابتدا دانشگاه را انتخاب کن.");
    if (!collegeName.trim()) return setMessage("نام دانشکده را وارد کن.");
    if (!fieldName.trim()) return setMessage("نام رشته را وارد کن.");
    setBusy(true); setMessage("");
    const result = await apiFetch("AcademicStructureImport/OpenAlex/Approve", "post", {
      universityId: Number(universityId), collegeName: collegeName.trim(), fieldName: fieldName.trim()
    });
    setBusy(false);
    if (!result.ok) return setMessage(result.error || "ثبت دانشکده و رشته انجام نشد.");
    setCollegeName(""); setFieldName("");
    await loadRelations(universityId);
    setMessage("دانشکده و رشته ثبت و به دانشگاه متصل شد.");
  };

  return <section className="university-structure-manager">
    <div className="university-structure-title">
      <div><h2>دانشکده‌ها و رشته‌های دانشگاه</h2><p>ساختار دانشگاه را قبل از تأیید استادها از اینجا تکمیل کن.</p></div>
      {selectedUniversity && <span>{selectedUniversity.name}</span>}
    </div>
    <div className="university-structure-form">
      <label>دانشگاه<select value={universityId} onChange={(event) => { setUniversityId(event.target.value); setMessage(""); }}><option value="">انتخاب دانشگاه</option>{allUniversities.map((item) => <option key={item.universityId} value={item.universityId}>{item.name}</option>)}</select></label>
      <label>نام دانشکده<input value={collegeName} onChange={(event) => setCollegeName(event.target.value)} placeholder="مثلاً School of Medicine" /></label>
      <label>نام رشته<input value={fieldName} onChange={(event) => setFieldName(event.target.value)} placeholder="مثلاً Medicine" /></label>
      <button type="button" disabled={busy} onClick={submit}>{busy ? "در حال ثبت..." : "افزودن دانشکده و رشته"}</button>
    </div>
    {message && <div className="university-structure-message">{message}</div>}
    {universityId && <div className="university-structure-list">
      <strong>ساختارهای ثبت‌شده ({relations.length})</strong>
      {relations.length === 0 ? <p>هنوز دانشکده/رشته‌ای برای این دانشگاه ثبت نشده است.</p> : <div>{relations.map((item) => <span key={item.collegeFieldId}>{item.college?.name || "دانشکده نامشخص"}<b>←</b>{item.field?.name || "رشته نامشخص"}</span>)}</div>}
    </div>}
  </section>;
}
